// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errorMessage: '' };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { errorMessage: error.stack || error.message };
    }
    render() {
        if (this.state.errorMessage) {
            // You can render any custom fallback UI
            return React.createElement("span", { style: { color: 'red', whiteSpace: 'pre' } }, this.state.errorMessage);
        }
        return this.props.children;
    }
}
